function splitRequestParams (params = {}) {
  const {
    config = {},
    ...requestParams
  } = params
  return {
    config,
    requestParams,
  }
}

const actions = {
  cardPrices ({ rootState }, params = {}) {
    const { config, requestParams } = splitRequestParams(params)
    return rootState.axios.get('/jyo/v1frontend/jyorder-cardwt/card-prices', {
      ...config,
      params: requestParams,
    })
  },
  index ({ rootState }, params = {}) {
    const { config, requestParams } = splitRequestParams(params)
    return rootState.axios.get('/jyo/v1frontend/jyorder-cardwt/index', {
      ...config,
      params: requestParams,
    })
  },
  view ({ rootState }, params = {}) {
    const { config, requestParams } = splitRequestParams(params)
    return rootState.axios.get('/jyo/v1frontend/jyorder-cardwt/view', {
      ...config,
      params: requestParams,
    })
  },
  create ({ rootState }, params = {}) {
    const { config, requestParams } = splitRequestParams(params)
    return rootState.axios.post('/jyo/v1frontend/jyorder-cardwt/create', requestParams, config)
  },
  cancel ({ rootState }, params = {}) {
    const { config, requestParams } = splitRequestParams(params)
    return rootState.axios.post('/jyo/v1frontend/jyorder-cardwt/cancel', requestParams, {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}

export default {
  namespaced: true,
  actions,
}
